// true if value only contains digits.
export function isNumericString(value) {
  return /^-?\d+$/.test(value);
}